const common = {
  focus: {
    inserted: (el) => {
      el.querySelector('input').focus()
    },
  },
}

export default common
